import { render } from "./DadosFinanceiros.vue?vue&type=template&id=683709e2&scoped=true"
import script from "./DadosFinanceiros.vue?vue&type=script&lang=js"
export * from "./DadosFinanceiros.vue?vue&type=script&lang=js"

import "./DadosFinanceiros.vue?vue&type=style&index=0&id=683709e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683709e2"]])

export default __exports__